import React from 'react'
import { Card, Container, Row, Col} from 'react-bootstrap'
import { Link } from 'react-router-dom'
import '../Staff/index.css'
import brianImage from '../../assets/images/Brian_Morton.jpg'
import josephImage from '../../assets/images/Joseph_Giannasio.jpg'
import erenImage from '../../assets/images/Eren_Kamiyama.jpg'

function index() {
    return (
        <div>
            <Container fluid style={{padding: '20px'}}>
               <Row>
                 {/* <CardDeck className="cardDeckPadding"> */}
                        <Col sm={12} lg={3}>
                        <Card style={{marginBottom:"20px"}}>
                            {/* <Card.Img variant="top" src="https://via.placeholder.com/50" /> */}
                            <Card.Body>
                                <Card.Title>Dr. Tina Archer</Card.Title>
                                <Card.Text>
                                    Dr. Tina Archer, brings extensive experience
                                    in the delivery of mental health services. Dr. Archer developed and
                                    managed Castle Medical Center's psychiatric and addictions inpatient and
                                    outpatient programs and managed the Bobby Benson Residential
                                    Treatment Program. Dr. Archer has extensive experience in
                                    developing and in attaining accreditation for inpatient, residential and
                                    outpatient treatment facilities and managing these programs.
                                    <br /><br />
                                    <Link to="Staff/Tina_Archer">Read More</Link>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                        </Col>
                            <Col sm={12} lg={3}>                        
                            <Card style={{marginBottom:"20px"}}>
                            <Card.Img variant="top" src={brianImage} />
                            <Card.Body>
                                <Card.Title>Brian Morton - President</Card.Title>
                                <Card.Text>
                                Brian Morton, provides the leadership, management and vision necessary to ensure 
                                the company’s current and future success. Mr. Morton is responsible for successfully 
                                managing and improving the strategic, financial, operational, and clinical performance 
                                of CARE Hawaii. Mr. Morton also is also entrusted to build solid effective relationships 
                                with various stakeholders.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                        </Col>
                        <Col sm={12} lg={3}>
                        <Card style={{marginBottom:"20px"}}>
                            <Card.Img variant="top" src={erenImage} />
                            <Card.Body>
                                <Card.Title>Eren Kamiyama - Chief Operating Officer</Card.Title>
                                <Card.Text>
                                Eren Kamiyama is a Marriage and Family Therapist and Certified Substance
                                Abuse Counselor. Ms. Kamiyama is responsible for overseeing operations
                                and handling internal affairs of the organization. Ms. Kamiyama is responsible
                                for developing the strategies and policies required to ensure that the
                                organization will meet the goals set by the team. Ms. Kamiyama also
                                monitors other organization performance indicators while continually seeking
                                to identify ways to be more cost efficient and improving quality performance in
                                programs in their ongoing efforts to meet the organization’s goals.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                        </Col>
                        <Col sm={12} lg={3}>
                        <Card style={{marginBottom:"20px"}}>
                            <Card.Img variant="top" src={josephImage}/>
                            <Card.Body>
                                <Card.Title>Dr. Joseph Giannasio - Medical Director</Card.Title>
                                <Card.Text>
                                The Medical Director Dr. Joseph Giannasio, provides psychiatric direction
                                to CARE and gives input to the organization regarding the structure of
                                service delivery and the soundness of clinical practice. He, along with
                                other psychiatrists and APRNrx’s, provide supervision of programs and
                                direct care for person’s in CARE’s services. All Psychiatrists must be
                                licensed to practice medicine in Hawaii, have completed five (5) years of
                                post graduate medical training three (3) of which must be in psychiatry,
                                have graduated from an approved residency and certified by the American
                                Board of Psychiatry and Neurology.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                        </Col>
                        {/* </CardDeck> */}
        </Row>
        </Container>
                        
         
        </div>
    )
}

export default index
